<template>
  <v-container>
    <v-form v-model="isValidForm">
      <v-row>
        <v-col cols="6">
          <v-autocomplete
            v-model="evaluacionDesempenio.idEvaluador"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            :items="evaluadores"
            item-value="idPersonal"
            item-text="CUIP"
            item-color="secondary"
            :rules="required"
            hint="Presione la tecla Enter para realizar la búsqueda"
            persistent-hint
            @keyup.enter="fetchEvaluadores($event.target.value)"
          >
            <template v-slot:label>Personal evaluador <span class="red--text">*</span> </template>
            <template v-slot:item="data">
              <v-list-item-avatar>
                <v-img v-if="data.item.foto !== ''" :src="data.item.foto"></v-img>
                <v-icon v-else>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ data.item.CUIP }}</v-list-item-title>
                <v-list-item-subtitle>{{ getFullName(data.item) }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="evaluacionDesempenio.idPeriodicidad"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            :items="periodicidad"
            item-value="id"
            item-text="title"
            item-color="secondary"
            :rules="required"
            @change="setFechaInicial($event)"
          >
            <template v-slot:label>Periodicidad <span class="red--text">*</span> </template>
          </v-select>
        </v-col>
        <v-col>
          <v-menu
            v-model="menuFechaInicio"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="fechaInicioFormatted"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                :rules="required"
              >
                <template v-slot:label>Fecha inicio <span class="red--text">*</span> </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="evaluacionDesempenio.fechaInicio" @input="menuFechaInicio = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col>
          <v-text-field
            :value="fechaFinFormatted"
            append-icon="mdi-calendar"
            readonly
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
          >
            <template v-slot:label>Fecha de conclusión <span class="red--text">*</span> </template>
          </v-text-field>
        </v-col>
        <v-col>
          <v-menu
            v-model="menuFechaAplicacion"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="fechaAplicacionFormatted"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                :rules="required"
              >
                <template v-slot:label>Fecha de aplicación <span class="red--text">*</span> </template>
              </v-text-field>
            </template>
            <v-date-picker
              v-model="evaluacionDesempenio.fechaAplicacion"
              @input="menuFechaAplicacion = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-select
            label="Tipo de evaluación de productividad"
            v-model="selectedTipoEvaluacion"
            :items="filteredTipoEvaluacion"
            item-value="id"
            item-text="title"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" align="center">
          <v-btn
            color="secondary"
            @click="generaProcesoEvaluacion()"
            :disabled="isLoading || !isValidForm"
            :loading="isLoading"
          >
            Guardar información</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import EvaluacionDesempenio from '../../../../modules/evaluacion-desempeño/domain/entities/EvaluacionDesempenio'
import { API_DATE_FORMAT, VUETIFY_DATE_FORMAT } from '../../../../const'
import CreateEvaluacionDisciplinaAdministrativaUseCase from '../../../../modules/evaluacion-desempeño/application/usecases/CreateEvaluacionDisciplinaAdministrativa.usecase'
import EvaluacionDisciplinaAdministrativaApiRepository from '../../../../modules/evaluacion-desempeño/infrastructure/EvaluacionDisciplinaAdministrativaApi.repository'
import CreateEvaluacionDisciplinaOperativaUseCase from '@/modules/evaluacion-desempeño/application/usecases/CreateEvaluacionDisciplinaOperativa.usecase'
import RespetoPrincipiosApiRepository from '@/modules/evaluacion-desempeño/infrastructure/RespetoPrincipiosApi.repository'
import CreateRespetoPrincipiosUseCase from '@/modules/evaluacion-desempeño/application/usecases/CreateRespetoPrincipios.usecase'
import EvaluacionDisciplinaOperativaApiRepository from '@/modules/evaluacion-desempeño/infrastructure/EvaluacionDisciplinaOperativaApi.repository'
import CreateEvaluacionProductividadUseCase from '@/modules/evaluacion-desempeño/application/usecases/CreateEvaluacionProductividad.usecase'
import EvaluacionProductividadApiRepository from '@/modules/evaluacion-desempeño/infrastructure/EvaluacionProductividadApi.repository'
import CreateConjuntoEvaluacionesUseCase from '@/modules/evaluaciones/application/CreateConjuntoEvaluaciones.usecase'
import EvaluacionesApiRepository from '@/modules/evaluaciones/infrastructure/EvaluacionesApi.repository'
import Notificacion from '@/modules/notificaciones/domain/Notificacion'
import { NotificationFactory, NOTIFICATION_TYPES } from '@/modules/notificaciones/domain/NotificationFactory'

export default {
  props: {
    idPersonal: {
      type: Number,
      required: true,
    },
    personalEvaluado: {
      type: Object,
      required: true,
    },
    externalLoading: {
      type: Boolean,
      default: false,
    },
  },

  async mounted() {
    await this.fetchTipoEvaluacion()
  },

  data() {
    return {
      isValidForm: false,
      loading: false,
      evaluacionDesempenio: new EvaluacionDesempenio(this.idPersonal),
      menuFechaInicio: false,
      menuFechaFin: false,
      menuFechaAplicacion: false,
      required: [(v) => !!v || 'Este campo es requerido'],
      selectedTipoEvaluacion: null,
    }
  },

  watch: {
    'evaluacionDesempenio.fechaInicio'(newVal) {
      if (newVal) {
        this.evaluacionDesempenio.fechaConclusion = moment(newVal, VUETIFY_DATE_FORMAT)
          .add(3, 'months')
          .subtract(1, 'day')
          .format(VUETIFY_DATE_FORMAT)
      } else {
        this.evaluacionDesempenio.fechaConclusion = null
      }
    },
  },

  computed: {
    isLoading() {
      return this.loading || this.externalLoading
    },
    ...mapGetters('personal', { evaluadores: 'getEvaluadores' }),
    ...mapGetters('periodicidad', { periodicidad: 'getPeriodicidad' }),
    ...mapGetters('faltasAdministrativas', { faltasAdministrativas: 'getFaltasAdministrativas' }),

    fechaInicioFormatted: function () {
      return this.evaluacionDesempenio.fechaInicio
        ? moment(this.evaluacionDesempenio.fechaInicio, VUETIFY_DATE_FORMAT).format(this.API_DATE_FORMAT)
        : ''
    },

    fechaFinFormatted: function () {
      return this.evaluacionDesempenio.fechaInicio
        ? moment(this.evaluacionDesempenio.fechaInicio, VUETIFY_DATE_FORMAT)
            .add(3, 'months')
            .subtract(1, 'day')
            .format(this.API_DATE_FORMAT)
        : ''
    },

    fechaAplicacionFormatted: function () {
      return this.evaluacionDesempenio.fechaAplicacion
        ? moment(this.evaluacionDesempenio.fechaAplicacion, VUETIFY_DATE_FORMAT).format(this.API_DATE_FORMAT)
        : ''
    },

    ...mapGetters('tipoEvaluacion', {
      tipoEvaluacion: 'getTipoEvaluacion',
    }),

    filteredTipoEvaluacion: function () {
      return this.tipoEvaluacion.filter((tipoEvaluacion) => {
        return tipoEvaluacion.id == 1 || tipoEvaluacion.id == 3
      })
    },
  },

  methods: {
    ...mapActions('personal', ['fetchEvaluadores']),
    ...mapActions('tipoEvaluacion', ['fetchTipoEvaluacion']),
    ...mapActions('notificaciones', ['createNotification']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    setFechaInicial(event) {
      const currentYear = moment().year()

      const TRIMESTRE_INICIO = {
        1: `${currentYear}-01-01`,
        2: `${currentYear}-04-01`,
        3: `${currentYear}-07-01`,
        4: `${currentYear}-10-01`,
      }

      this.evaluacionDesempenio.fechaInicio = TRIMESTRE_INICIO[event] || null
    },

    async generaProcesoEvaluacion() {
      try {
        this.loading = true
        this.SET_SNACKBAR_MESSAGE('Guardando información...')

        const disciplinaAdministrativaPromise = await new CreateEvaluacionDisciplinaAdministrativaUseCase(
          new EvaluacionDisciplinaAdministrativaApiRepository()
        ).execute(this.evaluacionDesempenio, this.faltasAdministrativas)

        const disciplinaOperativaPromise = await new CreateEvaluacionDisciplinaOperativaUseCase(
          new EvaluacionDisciplinaOperativaApiRepository()
        ).execute(this.evaluacionDesempenio)

        const respetoPrincipiosPromise = await new CreateRespetoPrincipiosUseCase(
          new RespetoPrincipiosApiRepository()
        ).execute(this.evaluacionDesempenio)

        const productividadPromise = await new CreateEvaluacionProductividadUseCase(
          new EvaluacionProductividadApiRepository()
        ).execute(this.evaluacionDesempenio, this.selectedTipoEvaluacion)

        const [disciplinaAdministrativaId, disciplinaOperativaId, respetoPrincipiosId, productividadId] =
          await Promise.all([
            disciplinaAdministrativaPromise,
            disciplinaOperativaPromise,
            respetoPrincipiosPromise,
            productividadPromise,
          ])

        await new CreateConjuntoEvaluacionesUseCase(EvaluacionesApiRepository).execute({
          fk_idRespetoPrincipios: respetoPrincipiosId,
          fk_idDisciplinaAdministrativa: disciplinaAdministrativaId,
          fk_idDisciplinaOperativa: disciplinaOperativaId,
          fk_idProductividad: productividadId,
          idPersonal: this.idPersonal,
        })

        await this.sendNotificacion()

        this.SET_SNACKBAR_MESSAGE('Información guardada correctamente.')

        this.$emit('save', {
          disciplinaAdministrativaId,
          disciplinaOperativaId,
          respetoPrincipiosId,
          productividadId,
        })
      } catch (error) {
        console.error(error)
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al guardar la información.')
        this.loading = false
      }
    },

    getFullName(persona) {
      if (!persona) return ''
      return [persona.nombre, persona.segundoNombre, persona.apaterno, persona.amaterno].filter(Boolean).join(' ')
    },

    async sendNotificacion() {
      const evaluado = this.personalEvaluado || {}
      const nombreEvaluado = this.getFullName(evaluado) || 'Sin evaluado'
      const cuipEvaluado = evaluado.CUIP || 'Sin CUIP'

      const nombreEvaluadorLocal = [
        localStorage.getItem('nombre'),
        localStorage.getItem('segundoNombre'),
        localStorage.getItem('apaterno'),
        localStorage.getItem('amaterno'),
      ]
        .filter(Boolean)
        .join(' ')

      const usuarioFromStore = this.$store?.getters?.['personal/getPersonal']
      const nombreEvaluadorStore = usuarioFromStore ? this.getFullName(usuarioFromStore) : ''
      const nombreEvaluador = nombreEvaluadorStore || nombreEvaluadorLocal || 'Usuario'
      const mensaje = `El personal ${nombreEvaluador} ha registrado un proceso de evaluación de desempeño al elemento ${nombreEvaluado} con CUIP: ${cuipEvaluado}.`

      const notification = new NotificationFactory(Notificacion).createNotification(
        NOTIFICATION_TYPES.CAMBIO_EVALUACION_DESEMPENO,
        {
          responsable: Number(localStorage.getItem('idPersonal')),
          afectado: this.idPersonal,
          mensaje,
        }
      )

      await this.createNotification(notification)
    },
  },
}
</script>
